import gql from 'graphql-tag'

import { responsiveImageFragment } from '../fragments/images.js'
import { seoFragment } from '../fragments/seo.js'
import { sectionFragment, slimBannerFragment, zoomMasonryFragment } from '../fragments/body.js'
import { heroFragment } from '../fragments/hero.js'

export const getHome = gql`
  ${responsiveImageFragment}
  ${seoFragment}
  ${heroFragment}
  ${zoomMasonryFragment}
  ${slimBannerFragment}
  ${sectionFragment}
  query getHome($locale: SiteLocale) {
    homepage(locale: $locale) {
      seo {
        ...SeoFragment
      }
      hero {
        ...HeroFragment
      }
      body {
        __typename
        ... on ZoomMasonryRecord {
          ...ZoomMasonryFragment
        }
        ... on SlimBannerRecord {
          ...SlimBannerFragment
        }
        ... on SectionRecord {
          ...SectionFragment
        }
      }
    }
  }
`
